import { useCurrentSessionOrThrow } from '@/session/hooks/internal/useCurrentSessionOrThrow';

export const useCurrentUser = () => useCurrentSessionOrThrow().currentUser;
